import * as React from "react";
import * as moment from "moment";
import { GlobalSearchResultModel } from "../model/autogen/GlobalSearchResultModel";
import List from "@material-ui/core/List/List";
import { ItemSearchModel } from "../model/autogen/ItemSearchModel";
import ListSubheader from "@material-ui/core/ListSubheader/ListSubheader";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography/Typography";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ExpansionPanel from "@material-ui/core/ExpansionPanel/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary/ExpansionPanelSummary";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails/ExpansionPanelDetails";
import { DOCUMENT_TYPE_ICONS } from "./document-icons";
import { AbstractDocumentKind } from "../model/autogen/AbstractDocumentKind";
import { NBSP } from "../utils/string";
import { NoteItemRoute, FaqItemRoute, PeopleItemRoute, MPItemRoute, IssueBriefItemRoute, MediaLinesItemRoute, OpinionEditorialItemRoute, QuoteItemRoute, /*TweetItemRoute,*/ AchievementItemRoute, ResourceItemRoute } from "../route-paths";
import Checkbox from '@material-ui/core/Checkbox';
import { ListItemSecondaryAction, Tooltip } from "@material-ui/core";
import StarBorder from "@material-ui/icons/StarBorder"
import Star from "@material-ui/icons/Star"
import DragHandle from "@material-ui/icons/DragHandle"
import { DebateNotesRequestFactory } from "../model/autogen/DebateNotesController";
import { MediaLinesRequestFactory } from "../model/autogen/MediaLinesController";
import { IAuthContextProps, withAuthContext } from "../components/with-auth-context";
import { DragDropContext, Droppable, Draggable, DraggableProvidedDragHandleProps, DropResult } from 'react-beautiful-dnd';
import amber from '@material-ui/core/colors/amber';
import { UserLevel } from "../model/autogen/UserLevel";
import { canViewNonePrioritisedMediaLinesInMediaLinesPage } from "../model/content-access";
import InfiniteScroll from 'react-infinite-scroller';
import { Searching } from "../pages/infinite-scroller-helper";
import { SearchableContentType } from "../model/autogen/SearchableContentType";
import { SanitisedHtml } from "./html";

export function isEmptyResultSet(results: GlobalSearchResultModel) {

    if (!results) return false;

    return results.debateNotes && results.debateNotes.length == 0
        && results.mediaLines && results.mediaLines.length == 0
        && results.mpProfiles && results.mpProfiles.length == 0
        && results.faQs && results.faQs.length == 0
        && results.issueBriefs && results.issueBriefs.length == 0
        && results.people && results.people.length == 0
        && results.opinionEditorials && results.opinionEditorials.length == 0
        && results.quotes && results.quotes.length == 0
        && results.tweets && results.tweets.length == 0
        && results.achievements && results.achievements.length == 0
}


export function getSortable(items: ItemSearchModel[]): ItemSearchModel[] {
    return items.filter((item) => item.priority !== null && item.priority !== undefined && item.priority >= 0)
}

export function getNoneSortable(items: ItemSearchModel[]): ItemSearchModel[] {
    return items.filter((item) => item.priority === undefined || item.priority === null || item.priority < 0)
}

export function isSingularResultSet(results: GlobalSearchResultModel) {
    const categories = [results.debateNotes, results.faQs, results.issueBriefs, results.mediaLines, results.mpProfiles, results.people, results.quotes, results.opinionEditorials, results.tweets, results.achievements];
    return categories.filter(cat => cat && cat.length > 0).length == 1;
}

export function getNoneEmptyList(results: GlobalSearchResultModel): ItemSearchModel[] {
    //results = results ? results : this.state.results;
    return results[getNoneEmptyListKey(results)];
}

export function getNoneEmptyListKey(results: GlobalSearchResultModel): string {
    for (let key in results) {
        if (results[key] && results[key].length > 0)
            return key
    }

    window.alert('did not find key');
    return '';
}

export function orderByPriority(state: IGlobalSearchResultListProps) {
    var stateCopy = JSON.parse(JSON.stringify(state));

    const list = getNoneEmptyList(stateCopy.results);

    const sortables = getSortable(list).sort((x, y) => {
        if (x.priority !== undefined && y.priority !== undefined)
            return x.priority - y.priority;

        return 0;
    });

    const noneSortables = getNoneSortable(list).sort((x, y) => {
        if (x.date > y.date) return -1;
        if (x.date < y.date) return 1;

        return 0;
    });

    const key = getNoneEmptyListKey(stateCopy.results);
    stateCopy.results[key] = sortables;
    stateCopy.results[key] = stateCopy.results[key].concat(noneSortables);

    return stateCopy
}

export const MediaLinesSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} draggableProps={props.draggableProps} onFavourite={props.onFavourite} result={props.result} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.MediaLines]} linkRoute={MediaLinesItemRoute(props.deletedOnly)} />;

export const DebateNotesSearchItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} draggableProps={props.draggableProps} onFavourite={props.onFavourite} result={props.result} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.DebateNotes]} linkRoute={NoteItemRoute(props.deletedOnly)} />;

export const FAQSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={FaqItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.FAQ]} />;

export const MPSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={MPItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.ProfileOfMP]} />;

export const BriefSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={IssueBriefItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.IssueBrief]} />;

export const PersonSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={PeopleItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.Person]} />;

export const OpinionEditorialSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={OpinionEditorialItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[AbstractDocumentKind.OpinionEditorial]} />;

export const QuoteSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={QuoteItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[SearchableContentType.Quote]} />;

// export const TweetSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={TweetItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[SearchableContentType.Tweet]} />;

export const AchievementSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={AchievementItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[SearchableContentType.Achievement]} />;

export const ResourceSearchResultItem = (props: ISearchResultListItemProps) => <GlobalSearchResultListItem showTags={props.showTags} result={props.result} linkRoute={ResourceItemRoute(props.deletedOnly)} icon={DOCUMENT_TYPE_ICONS[SearchableContentType.Resource]} />;

export const GlobalSearchResultListItem = (props: IGlobalSearchResultListItemProps) => {
    const { linkRoute, result, icon, onFavourite, draggableProps, showTags } = props;

    let secHtml = result.searchFragments.map(fm => {

        return fm.replace(/nzrh-highlighted-field-begin/g, "<span style='background-color:yellow;font-weight:bold'>")
            .replace(/nzrh-highlighted-field-end/g, "</span>")
        })
        .join("<br/>");

    if (result.kind === SearchableContentType.ProfileOfMP && result.topLine !== undefined) {
        secHtml = result.topLine + "<br />" + secHtml
    }

    let title = result.title

    if (result.kind === SearchableContentType.Quote) {
        secHtml = result.quoteTopic || "";
        if (result.quotePhrase) {
            if (result.quotePhrase.length > 51) {
                title = result.quotePhrase.slice(0, 51) + " ..."
            } else {
                title = result.quotePhrase
            }
        }       
    }
    
    let secTags = result.matchedTags
        .map(tag => {
            return tag.replace(/nzrh-highlighted-field-begin/g, "")
                .replace(/nzrh-highlighted-field-end/g, "")
        })
        .join(", ")
    if (showTags && result.tags && result.tags.length > 0) {
        if (secHtml.length > 0)
            secHtml += "<br/>";
        secHtml += `<p>Tags: <strong>${result.tags.join(", ")}</strong></p>`;
    }
    if (result.matchedTags && result.matchedTags.length > 0) {
        secHtml += `<br/><p>Result matched on tag(s): <strong>${secTags}</strong></p>`;
    }

    return <ListItem divider={true} button={true}
        component={(props => <Link to={linkRoute(result.documentId)} className={props.className}>{props.children}</Link>)}>
        <ListItemIcon>
            <>
                <div style={{ flexDirection: "column", textAlign: "center", flex: "0 0 80px" }}>
                    {icon}
                    <Typography>{moment(result.date).format("DD MMM YYYY")}</Typography>
                </div>
            </>
        </ListItemIcon>
        <ListItemText primary={title} secondary={<SanitisedHtml html={secHtml} />} />
        {onFavourite && <ListItemSecondaryAction>
            <span style={{ display: 'inline' }}>
                {draggableProps && <div style={{ display: 'inline', width: '50px', height: '50px' }} {...draggableProps}>
                    <DragHandle />
                </div>}
                <Tooltip title="Highlight" placement="left">
                    <Checkbox
                        style={{
                            color: amber[500]
                        }}
                        checked={result.priority !== null && result.priority !== undefined && result.priority >= 0}
                        onChange={(sender, checked) => onFavourite && onFavourite(result.documentId, checked)}
                        icon={<StarBorder />}
                        checkedIcon={<Star />}
                    ></Checkbox>
                </Tooltip>
            </span>
        </ListItemSecondaryAction>}


    </ListItem>;
}

export interface ISearchResultListItemProps {
    result: ItemSearchModel;
    showTags?: boolean;
    deletedOnly?: boolean;
    onFavourite?: (id: number, fave: boolean) => void;
    draggableProps?: DraggableProvidedDragHandleProps | null;
}

export interface IGlobalSearchResultListItemProps extends ISearchResultListItemProps {
    linkRoute: (id: number) => string;
    icon: JSX.Element;
    onFavourite?: (id: number, fave: boolean) => void;
    draggableProps?: DraggableProvidedDragHandleProps | null;
}

export interface IGlobalSearchResultListProps {
    accordionMode?: boolean;
    deletedOnly?: boolean;
    showItemTags?: boolean;
    results: GlobalSearchResultModel;
    isSearchingFromHeader?: boolean; // in future before adding functionality to this component consider breaking it into smaller components
    requestMoreResults?: () => void;
}

interface IHasMore {
    hasMore?: boolean
}

type IGlobalSearchResultProps = IHasMore & IGlobalSearchResultListProps & IAuthContextProps;

export interface IGlobalSearchResultListState {
    showMoreIsVisible?: boolean;
}

interface IResultSetPanelProps {
    kind: AbstractDocumentKind | SearchableContentType;
    ItemComponentType: React.ComponentType<ISearchResultListItemProps>;
    items?: ItemSearchModel[];
    deletedOnly?: boolean;
}

function cssClassify(kind: AbstractDocumentKind | SearchableContentType): string {
    return `${kind}`.replace(/ /, '-');
}

const ResultSetPanel = (props: IResultSetPanelProps) => {
    const { items, kind, deletedOnly, ItemComponentType } = props;
    return items && items.length > 0 ? (<>
        <ExpansionPanel data-category={kind}>
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                <Typography>{DOCUMENT_TYPE_ICONS[kind]}{NBSP}{kind} ({items.length})</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <List component="nav">
                    {items.map((dbt, i) => <ItemComponentType key={`${cssClassify(kind)}-${i}`} deletedOnly={deletedOnly} result={dbt} />)}
                </List>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    </>) : <noscript />;
}

interface IResultSetListProps extends IResultSetPanelProps {
    isNoneSearchSingleCategory: boolean;
    showItemTags?: boolean;
}

const ResultSetList = (props: IResultSetListProps) => {
    const { isNoneSearchSingleCategory, items, kind, deletedOnly, showItemTags, ItemComponentType } = props;
    return items && items.length > 0 ? (<>
        {!isNoneSearchSingleCategory && <ListSubheader>{DOCUMENT_TYPE_ICONS[kind]}{NBSP}{kind} ({items.length})</ListSubheader>}
        {items.map((dbt, i) => <ItemComponentType showTags={showItemTags} key={`${cssClassify(kind)}-${i}`} deletedOnly={deletedOnly} result={dbt} />)}
    </>) : <noscript />;
}

type GlobalSearchResultListProps = IGlobalSearchResultListProps

type GlobalSearchResultListState = GlobalSearchResultListProps & IGlobalSearchResultListState;

class GlobalSearchResultListComponent extends React.Component<IGlobalSearchResultProps, GlobalSearchResultListState> {
    constructor(props: IGlobalSearchResultProps) {
        super(props);
        const { results } = props as GlobalSearchResultListProps;
        const isSingleCategory = isSingularResultSet(results);
        if (isSingleCategory)
            this.state = orderByPriority(props);
        else
            this.state = JSON.parse(JSON.stringify(props));
    }

    componentWillReceiveProps(nextProps: GlobalSearchResultListProps) {
        const isSingleCategory = isSingularResultSet(nextProps.results);
        if (isSingleCategory)
            this.setState(orderByPriority(JSON.parse(JSON.stringify(nextProps))));
        else
            this.setState(JSON.parse(JSON.stringify(nextProps)));
    }

    buildSearchResults = () => {
        var stateCopy = JSON.parse(JSON.stringify(this.state));
        const { results } = stateCopy as GlobalSearchResultListProps;
        const isNoneSearchSingleCategory = isSingularResultSet(results) && !this.props.isSearchingFromHeader;

        const canPrioritise = this.props.user.level >= UserLevel.Editor;
        const canViewNonePrioritisedMediaLines = canViewNonePrioritisedMediaLinesInMediaLinesPage(this.props.user) || this.props.isSearchingFromHeader;
        //
        // todo: break this code block down, lots of copy+paste with just data values changing. This wasn't a huge deal before as the copy paste was mostly for data types
        // but the new sortable results for some search types (mediaLines/debateNotes) can and should be broken down into a single function which takes the component to be sorted
        // and props. I began the process with 'renderComponent', will need to rip more of the duplicated logic for the rest.
        if (this.props.accordionMode == true) {
            return <>
                <ResultSetPanel ItemComponentType={MediaLinesSearchResultItem} kind={AbstractDocumentKind.MediaLines} items={results.mediaLines} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={FAQSearchResultItem} kind={AbstractDocumentKind.FAQ} items={results.faQs} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={BriefSearchResultItem} kind={AbstractDocumentKind.IssueBrief} items={results.issueBriefs} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={PersonSearchResultItem} kind={AbstractDocumentKind.Person} items={results.people} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={DebateNotesSearchItem} kind={AbstractDocumentKind.DebateNotes} items={results.debateNotes} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={MPSearchResultItem} kind={AbstractDocumentKind.ProfileOfMP} items={results.mpProfiles} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={OpinionEditorialSearchResultItem} kind={AbstractDocumentKind.OpinionEditorial} items={results.opinionEditorials} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={QuoteSearchResultItem} kind={SearchableContentType.Quote} items={results.quotes} deletedOnly={this.props.deletedOnly} />
                {/*<ResultSetPanel ItemComponentType={TweetSearchResultItem} kind={SearchableContentType.Tweet} items={results.tweets} deletedOnly={this.props.deletedOnly} />*/}
                <ResultSetPanel ItemComponentType={AchievementSearchResultItem} kind={AbstractDocumentKind.Achievement} items={results.achievements} deletedOnly={this.props.deletedOnly} />
                <ResultSetPanel ItemComponentType={ResourceSearchResultItem} kind={AbstractDocumentKind.Resource} items={results.resources} deletedOnly={this.props.deletedOnly} />
            </>
        } else {
            return <List>
                {results.mediaLines && results.mediaLines.length > 0 ? (<>
                    {!isNoneSearchSingleCategory && <ListSubheader>{DOCUMENT_TYPE_ICONS[AbstractDocumentKind.MediaLines]}{NBSP}Media Lines ({results.mediaLines.length})</ListSubheader>}
                    {(!isNoneSearchSingleCategory || !canPrioritise) && (canViewNonePrioritisedMediaLines ? results.mediaLines : getSortable(results.mediaLines)).map((dbt, i) => <MediaLinesSearchResultItem onFavourite={canPrioritise ? (x: any, y: any) => { this.setSpecificPriority('mediaLines', x, y ? 0 : -1) } : undefined} key={`mediay-lines-${i}`} deletedOnly={this.props.deletedOnly} result={dbt} />)}

                    {!this.props.isSearchingFromHeader && isNoneSearchSingleCategory && canPrioritise && <div><DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div ref={provided.innerRef}>
                                    {getSortable(results.mediaLines || []).map((item, index) => (
                                        <Draggable key={item.documentId} draggableId={item.documentId + ""} index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}>
                                                    {
                                                        this.renderComponent(
                                                            MediaLinesSearchResultItem,
                                                            {
                                                                draggableProps: provided.dragHandleProps,
                                                                result: item,
                                                                deletedOnly: this.props.deletedOnly,
                                                                onFavourite: canPrioritise ? (x: any, y: any) => { this.setPriority('mediaLines', x, y ? 0 : undefined, true) } : undefined,
                                                                key: `mediay-lines-${index}`
                                                            }
                                                        )
                                                    }
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>

                        {getNoneSortable(results.mediaLines).map((item, index) => (
                            <div key={index}>{this.renderComponent(
                                MediaLinesSearchResultItem, {
                                    result: item,
                                    deletedOnly: this.props.deletedOnly,
                                    onFavourite: (x: any, y: any) => { this.setPriority('mediaLines', x, y ? 0 : undefined, true) },
                                    key: `mediay-lines-${index}`
                                })}</div>

                        ))}
                    </div>}
                </>) : undefined}

                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={FAQSearchResultItem} kind={AbstractDocumentKind.FAQ} items={results.faQs} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />
                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={PersonSearchResultItem} kind={AbstractDocumentKind.Person} items={results.people} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />
                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={BriefSearchResultItem} kind={AbstractDocumentKind.IssueBrief} items={results.issueBriefs} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />
                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={AchievementSearchResultItem} kind={AbstractDocumentKind.Achievement} items={results.achievements} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />
                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={ResourceSearchResultItem} kind={AbstractDocumentKind.Resource} items={results.resources} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />

                {results.debateNotes && results.debateNotes.length > 0 ? (<>
                    {!isNoneSearchSingleCategory && <ListSubheader>{DOCUMENT_TYPE_ICONS[AbstractDocumentKind.DebateNotes]}{NBSP}Debate Notes ({results.debateNotes.length})</ListSubheader>}
                    {(!isNoneSearchSingleCategory || !canPrioritise || this.props.isSearchingFromHeader) && results.debateNotes.map((dbt, i) => <DebateNotesSearchItem onFavourite={canPrioritise ? (x: any, y: any) => { this.setSpecificPriority('debateNotes', x, y ? 0 : -1) } : undefined} key={`debate-${i}`} deletedOnly={this.props.deletedOnly} result={dbt} />)}

                    {!this.props.isSearchingFromHeader && isNoneSearchSingleCategory && canPrioritise && <div><DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div ref={provided.innerRef}>
                                    {getSortable(results.debateNotes || []).map((item, index) => (
                                        <Draggable key={item.documentId} draggableId={item.documentId + ""} index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}>
                                                    {
                                                        this.renderComponent(
                                                            DebateNotesSearchItem,
                                                            {
                                                                draggableProps: provided.dragHandleProps,
                                                                result: item,
                                                                onFavourite: canPrioritise ? (x: any, y: any) => { this.setPriority('debateNotes', x, y ? 0 : undefined, true) } : undefined,
                                                                key: `debate-${index}`
                                                            }
                                                        )
                                                    }
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>

                        {getNoneSortable(results.debateNotes).map((item, index) => (
                            <div key={index}>{this.renderComponent(
                                DebateNotesSearchItem, {
                                    result: item,
                                    onFavourite: (x: any, y: any) => { this.setPriority('debateNotes', x, y ? 0 : undefined, true) },
                                    key: `debate-${index}`
                                })}</div>

                        ))}
                    </div>}

                </>) : undefined
                }

                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={MPSearchResultItem} kind={AbstractDocumentKind.ProfileOfMP} items={results.mpProfiles} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />
                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={OpinionEditorialSearchResultItem} kind={AbstractDocumentKind.OpinionEditorial} items={results.opinionEditorials} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />
                <ResultSetList showItemTags={this.props.showItemTags} ItemComponentType={QuoteSearchResultItem} kind={SearchableContentType.Quote} items={results.quotes} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} />
                {/* <ResultSetList ItemComponentType={TweetSearchResultItem} kind={SearchableContentType.Tweet} items={results.tweets} isNoneSearchSingleCategory={isNoneSearchSingleCategory} deletedOnly={this.props.deletedOnly} /> */}
            </List>
        }
    }

    onLoadMore = () => {
        if (this.props.requestMoreResults) {
            this.props.requestMoreResults();
        }
    }

    render(): JSX.Element {
        const results = this.buildSearchResults();


        return <>

            {isSingularResultSet(this.state.results) ? <InfiniteScroll
                pageStart={0}
                loadMore={this.onLoadMore}
                hasMore={this.props.hasMore}
                loader={<Searching key="searchingkey" />}>

                {results}

                {false && <div style={{ float: 'right' }}><Typography variant="subtitle1">No More Results</Typography></div>}
            </InfiniteScroll> : results
            }
        </>
    }

    setSpecificPriority = async (type: string, id: number, priority: number) => {
        var stateCopy = JSON.parse(JSON.stringify(this.state)) as GlobalSearchResultListProps;
        var list = stateCopy.results[type] as ItemSearchModel[];
        var doc = list.find((x) => x.documentId === id);
        if (doc) {
            doc.priority = priority >= 0 ? priority : undefined;
        }
        this.setState(stateCopy);

        const prioritiseAction = type === 'mediaLines' ? MediaLinesRequestFactory.prioritise : DebateNotesRequestFactory.prioritise;
        await this.props.callApi((fetcher) => prioritiseAction(fetcher, doc !== undefined ? doc.documentId : 0, priority));

    }

    renderComponent = (Comp: React.ComponentType<ISearchResultListItemProps>, props: ISearchResultListItemProps & React.Attributes): JSX.Element => {
        return <Comp {...props} />
    }

    setPriority = async (type: string, id: number, priority: number | undefined, withTimeout: boolean = false) => {
        // timeout is set so the star animation can play to the end before list rearranges itself
        setTimeout(async () => {
            var stateCopy = JSON.parse(JSON.stringify(this.state)) as GlobalSearchResultListProps;
            var list = getNoneEmptyList(stateCopy.results);
            if (list) {
                var doc = list.find((x) => x.documentId == id);
                if (doc !== undefined) {
                    doc.priority = priority;

                    const prioritiseAction = type === 'mediaLines' ? MediaLinesRequestFactory.prioritise : DebateNotesRequestFactory.prioritise;
                    await this.props.callApi((fetcher) => prioritiseAction(fetcher, doc !== undefined ? doc.documentId : 0, doc && doc.priority !== undefined ? doc.priority as number : -1));

                    this.setState(stateCopy);
                }
            }
        }, withTimeout ? 500 : 0);
    }

    private onDragEnd = async (result: DropResult) => {
        if (!result.destination) {
            return;
        }

        var stateCopy = JSON.parse(JSON.stringify(this.state));
        const key = getNoneEmptyListKey(this.state.results);
        if (key === '') {
            window.alert("all results are empty");
        }

        var sortables = getSortable(getNoneEmptyList(this.state.results));

        const reorder = (list: ItemSearchModel[], startIndex: number, endIndex: number): ItemSearchModel[] => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);

            return result;
        };
        sortables = reorder(sortables, result.source.index, result.destination.index);

        sortables.forEach((x, i) => {
            x.priority = i;
        })

        stateCopy.results[key] = sortables.concat(getNoneSortable(getNoneEmptyList(this.state.results)));

        this.setState(stateCopy);

        for (var i = 0; i < sortables.length; i++) {
            const toMove = sortables[i];
            this.setPriority(key, toMove.documentId, toMove.priority, false);
        }
    }
}

export const GlobalSearchResultList = withAuthContext(GlobalSearchResultListComponent) as React.ComponentType<IHasMore & IGlobalSearchResultListProps>;



// WEBPACK FOOTER //
// ./src/components/global-search-result-list.tsx